export {headingRank} from './lib/index.js'
